var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export var MESSAGES;
(function (MESSAGES) {
    MESSAGES["UserJoined"] = "SketchUserJoinedEvent";
    MESSAGES["CanvasUpdated"] = "SketchCanvasUpdatedEvent";
})(MESSAGES || (MESSAGES = {}));
export class Messenger {
    // eslint-disable-next-line no-useless-constructor
    constructor(client, sketch) {
        this.client = client;
        this.sketch = sketch;
        this.ready = false;
    }
    setup() {
        this.ready = true;
        this.api = this.client.apiResourceFactory("api/sketch");
        this.commonSubscription = this.client.events.setEventHandlers({
            onMessageReceived: (event) => {
                var _a;
                if (this.onMessage &&
                    ((_a = event.payload.type) === null || _a === void 0 ? void 0 : _a.startsWith("Sketch")) &&
                    event.payload.sketchId === this.sketch.sketchId) {
                    this.onMessage(event.payload);
                }
            },
        });
    }
    join(sketchId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ((_a = this.api) === null || _a === void 0 ? void 0 : _a.update({
                userId: this.sketch.userId,
                userEndpointId: this.sketch.userEndpointId,
            }, {
                urlPostfix: `${sketchId}`,
            }));
            this.version = res.version;
            return res.sketchId;
        });
    }
    create() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield ((_a = this.api) === null || _a === void 0 ? void 0 : _a.update({
                userId: this.sketch.userId,
                userEndpointId: this.sketch.userEndpointId,
            }, {
                urlPostfix: "/",
            }));
            return res.sketchId;
        });
    }
    post(events, target) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (events.length === 0 || !this.sketch.sketchId) {
                return;
            }
            yield ((_a = this.api) === null || _a === void 0 ? void 0 : _a.create({
                userId: this.sketch.userId,
                userEndpointId: this.sketch.userEndpointId,
                version: this.version,
                payload: {
                    events,
                    target,
                },
            }, {
                urlPostfix: `${this.sketch.sketchId}`,
            }));
        });
    }
    dispose() {
        var _a;
        (_a = this.commonSubscription) === null || _a === void 0 ? void 0 : _a.dispose();
    }
}
